import { FaHardHat, FaTools, FaPencilRuler, FaCity } from "react-icons/fa";
import { FaHelmetSafety } from "react-icons/fa6";

import images from "./images";


const About = {
  sub: "About Us",
  heading: "Building Excellence, One Project at a Time",
  description: "Welcome to BuildX, your trusted partner in construction. We specialize in high-quality residential, commercial, & industrial construction projects, innovation, & excellence in every build. Our team of experts is committed to delivering outstanding craftsmanship.",
  points: [
    {
      icon: <FaHardHat />,
      title: "Custom Construction",
    },
    {
      icon: <FaTools />,
      title: "Expert Renovations",
    },
    {
      icon: <FaHardHat />,
      title: "Quality Materials",
    },
    {
      icon: <FaPencilRuler />,
      title: "Precision Craftsmanship",
    },
    {
      icon: <FaCity />,
      title: "Commercial Projects",
    },
    {
      icon: <FaHelmetSafety />,
      title: "On-Budget Delivery",
    },
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About Image 1",
    alt2: "About Image 2",
  },
  button: {
    text: "Contact Us",
    link: "Contact-us",
  },
  experience: {
    years: "15+",
    label: "years of experience",
    icon: <FaHardHat />,
  },
};

export default About;  